import React, { useState, useEffect, useCallback } from "react";
import api from "../services/api";

const Row = ({ label, value, last }) => (
  <div
    className={
      "flex items-center justify-between" + (last ? "" : " border-b dark:border-slate-700")
    }
  >
    <span className="py-2 text-sm font-medium dark:text-slate-300">{label}</span>
    <span className="mr-3 text-sm text-stone-400">{value}</span>
  </div>
);

const formatDate = (value) =>
  value
    ? new Date(value).toLocaleString("default", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    : "—";

/**
 * One allaitement period. The quantity is a daily rate, so this also spells out
 * how many days it ran and what that adds up to — the figure the total on the
 * calf sheet is built from.
 */
function MilkDetail({ milkId, onDeleted }) {
  const [milk, setMilk] = useState(null);

  const getMilk = useCallback(() => {
    api
      .get("/milk/" + milkId)
      .then((response) => setMilk(response.data))
      .catch((error) => {
        console.error("There was an error getting the milk record!", error);
      });
  }, [milkId]);

  useEffect(() => {
    getMilk();
  }, [getMilk]);

  const handleDelete = () => {
    api
      .delete("/milk/" + milkId)
      .then(() => onDeleted())
      .catch((error) => {
        console.error("There was an error deleting the milk record!", error);
      });
  };

  if (!milk) {
    return <div></div>;
  }

  return (
    <div className="flex w-full flex-col">
      <div className="mx-3 rounded-lg bg-white md:bg-stone-100 dark:border-slate-700 dark:bg-slate-800">
        <div className="ml-3 flex flex-col">
          <Row label="Quantité par jour" value={`${milk.quantity} kg/jour`} />
          <Row label="Ad libitum" value={milk.adLibitum ? "Oui" : "Non"} />
          <Row label="Date de début" value={formatDate(milk.startDate)} />
          <Row label="Date de fin" value={formatDate(milk.endDate)} last />
        </div>
      </div>

      <div className="mt-3 px-3 md:self-end">
        <button
          className="w-full rounded-lg border border-stone-200 bg-white py-2 font-semibold text-red-500 shadow transition-colors duration-200 md:w-fit md:bg-red-600 md:px-3 md:text-white md:hover:bg-red-700 dark:border-red-900 dark:bg-red-600 dark:text-white dark:hover:bg-red-700"
          onClick={handleDelete}
        >
          Supprimer
        </button>
      </div>
    </div>
  );
}

export default MilkDetail;
